import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';

const container = document.getElementById('root');
// Create a root.
const root = ReactDOMClient.createRoot(container);

root.render( <
    React.StrictMode >
    <
    BrowserRouter >
    <
    Provider store = { store } >
    <
    App / >
    <
    /Provider> <
    /BrowserRouter> <
    /React.StrictMode>
);